import { FormControl, FormHelperText, FormLabel, Stack, TextField } from '@mui/material';
import React, { useMemo } from 'react';
interface FormInputProps {
  name?: string;
  label: string;
  value?: string | number | Date | null;
  type?: 'text' | 'number' | 'date' | 'password' | { type: 'multiLine'; maxRows?: number; minRows?: number };
  required?: boolean;
  helperText?: string;
  errorText?: string;
  hidden?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  variant?: 'filled' | 'outlined' | 'standard';
  direction?: 'row' | 'column';
  disabled?: boolean;
  autoComplete?: string;
  autoFocus?: boolean;
}

export function FormInput(props: FormInputProps) {
  const { direction = 'column' } = props;
  const [multiline, minRows, maxRows] = useMemo(() => {
    if (typeof props.type === 'object' && props.type.type === 'multiLine')
      return [true, props.type.minRows, props.type.maxRows];
    else return [false, undefined, undefined];
  }, [props.type]);
  const type = typeof props.type === 'string' ? props.type : multiline ? 'text' : 'text';

  return (
    <FormControl required={props.required} hiddenLabel={props.hidden} fullWidth variant={props.variant ?? 'standard'}>
      <Stack
        width="100%"
        direction={direction ?? 'column'}
        spacing={direction == 'row' ? 1 : 0}
        sx={{ alignItems: direction == 'row' ? 'center' : 'flex-start' }}
      >
        <FormLabel hidden={props.hidden}>{props.label}</FormLabel>
        <TextField
          name={props.name}
          type={type}
          value={props.value}
          onChange={props.onChange}
          hidden={props.hidden}
          variant={props.variant ?? 'standard'}
          disabled={props.disabled}
          fullWidth
          autoComplete={props.autoComplete}
          autoFocus={props.autoFocus}
          multiline={multiline}
          minRows={minRows}
          maxRows={maxRows}
        />
      </Stack>
      {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
      {props.errorText && <FormHelperText error>{props.errorText}</FormHelperText>}
    </FormControl>
  );
}
